export default __webpack_public_path__ + "static/media/cp_geo_hn.cba64dd3.svg";